require("./bootstrap");
var Cookies = require("js-cookie");

import { AdjustZoom } from "./components/adjustZoom";
import { initGlobalListeners } from "./helpers";

document.addEventListener("DOMContentLoaded", () => {
    new AdjustZoom().init();

    initMobileStickyMenu();

    document
        .querySelector("#mobileMenu nav")
        .addEventListener("click", function (e) {
            document.getElementById("hamburger").classList.remove("open");
            document.getElementById("mobileMenu").classList.remove("open");
        });
});
$(function () {
    initGlobalListeners();

    // const thequerystring = getUrlVars();
    // if (thequerystring["page"] !== undefined) {
    //     $("html, body").animate(
    //         {
    //             scrollTop: $("#all-sites").offset().top,
    //         },
    //         300
    //     );
    // }
});

document.getElementById("hamburger").addEventListener("click", function () {
    document.getElementById("hamburger").classList.toggle("open");
    document.getElementById("mobileMenu").classList.toggle("open");
});

// if (!Cookies.get("visited")) {
//     document.getElementById("cookie").classList.add("open");
// }

// document.querySelector("#cookie button").addEventListener("click", function () {
//     document.getElementById("cookie").classList.remove("open");
//     Cookies.set("visited", "true");
// });

function initMobileStickyMenu() {
    const headerContent = document.querySelector("header .header-content");
    const menuWrapper = document.querySelector(".fixed-mobile-menu-wrapper");
    const menuBar = menuWrapper?.querySelector(".mobile");

    if (!headerContent || !menuWrapper || !menuBar) return;

    const mobileMenuQuery = window.matchMedia("(max-width: 1050px)");
    let updateRequested = false;

    const updateMenuPosition = () => {
        updateRequested = false;

        if (!mobileMenuQuery.matches) {
            headerContent.style.minHeight = "";
            menuWrapper.style.top = "";
            return;
        }

        // Reserve the menu's natural space so the hero never needs a
        // calculated margin and does not jump when the menu becomes sticky.
        headerContent.style.minHeight = `${menuBar.getBoundingClientRect().height}px`;
        menuWrapper.style.top = `${Math.max(
            0,
            headerContent.getBoundingClientRect().top
        )}px`;
    };

    const requestMenuUpdate = () => {
        if (updateRequested) return;

        updateRequested = true;
        window.requestAnimationFrame(updateMenuPosition);
    };

    updateMenuPosition();
    window.addEventListener("scroll", requestMenuUpdate, { passive: true });
    window.addEventListener("resize", requestMenuUpdate);

    if (window.ResizeObserver) {
        new ResizeObserver(requestMenuUpdate).observe(menuBar);
    }
}

// function getUrlVars() {
//     var vars = [],
//         hash;
//     var hashes = window.location.href
//         .slice(window.location.href.indexOf("?") + 1)
//         .split("&");
//     for (var i = 0; i < hashes.length; i++) {
//         hash = hashes[i].split("=");
//         vars.push(hash[0]);
//         vars[hash[0]] = hash[1];
//     }
//     return vars;
// }

document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.questionnaire-questions');
    if (!container) return;

    const questionEls = Array.from(container.querySelectorAll('.question'));
    const resultBox = container.querySelector('.questionnaire-result');

    let successEl = resultBox.querySelector('.questionnaire-success');
    let notEl = resultBox.querySelector('.questionnaire-not');

    function showResult({ eligible }) {

        resultBox.style.display = 'block';
        if (eligible) {
            successEl.style.display = '';
            notEl.style.display = 'none';
        } else {
            successEl.style.display = 'none';
            notEl.style.display = '';
        }

        window.dataLayer.push({
            'event': 'eligibilityQuestionnaireFormSubmit', //fires only on successful study site search
            'formName': 'Eligibility Questionnaire',  //Pass the form name here  
            'eligibility': eligible ? "Eligible": "Ineligible" //Pass Eligibility Criteria: Eligible or Ineligible
        });
    }

    function evaluateQuestions() {
        const selections = questionEls.map(q => q.querySelector('.option.active'));
        const allAnswered = selections.every(s => !!s);
        if (!allAnswered) {
            resultBox.style.display = 'none';
            return;
        }

        const allEligible = selections.every(btn => {
            const raw = btn.dataset.eligible === '1';
            console.log("raw", raw)
            return raw;
        });

        showResult({ eligible: allEligible });
    }

    function onOptionClick(button) {
        const question = button.closest('.question');
        if (!question) return;

        const questionText = button.dataset.question;
        const optionText = button.dataset.option;

        window.dataLayer.push({
            'event': 'eligibilityQuestionaireSelect', //fires only on successful study site search
            'formName': 'Eligibility Questionnaire',   //Pass the form name here  
            'question': questionText,   //Pass the the question of selected answer in abbreviated form if possible  
            'answer': optionText   //Pass the selected answer here
        });

        const siblings = Array.from(question.querySelectorAll('.option'));
        siblings.forEach(s => s.classList.remove('active'));

        button.classList.add('active');

        evaluateQuestions();
    }

    container.addEventListener('click', function (e) {
        const btn = e.target.closest('.option');
        if (!btn) return;
        onOptionClick(btn);
    });
});
